var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "testimonials",
      class: {
        mobile: _vm.isMobile(_vm.$mq),
        authenticated: _vm.isAuthenticated
      }
    },
    [
      !_vm.isAuthenticated
        ? _c("LandingHeaderV2", {
            staticClass: "header",
            attrs: {
              "ax-params": {
                ids: {
                  headerLogInBtn: "clicked_login_from_header",
                  stickyHeaderSignUpBtn:
                    "clicked_start_free_trial_from_testimonials",
                  stickyHeaderLogInBtn: "clicked_login_from_testimonials"
                }
              }
            }
          })
        : _c("AppHeader"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { ref: "userReviews", staticClass: "container user-reviews" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "filters" }, [
          _c(
            "div",
            { staticClass: "types" },
            [
              _c(
                "button",
                {
                  staticClass: "dropdown",
                  class: { active: _vm.isTypeDropdownActive },
                  on: {
                    click: function($event) {
                      _vm.isTypeDropdownActive = !_vm.isTypeDropdownActive
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(_vm.activeType) + "\n        ")]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.isTypeDropdownActive
                  ? _c("div", { staticClass: "dropdown-menu" }, [
                      _c("ul", { staticClass: "unstyled" }, [
                        _vm.activeType != "Featured"
                          ? _c(
                              "li",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.changeType("Featured")
                                  }
                                }
                              },
                              [_vm._v("Featured")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.activeType != "All"
                          ? _c(
                              "li",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.changeType("All")
                                  }
                                }
                              },
                              [_vm._v("All")]
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "categories" }, [
            _c(
              "button",
              {
                class: { active: _vm.activeCategory == null },
                on: {
                  click: function($event) {
                    return _vm.changeCategory(null)
                  }
                }
              },
              [_vm._v("\n          All\n        ")]
            ),
            _vm._v(" "),
            _c("button", {
              class: { active: _vm.activeCategory == 1 },
              domProps: { innerHTML: _vm._s(_vm.userCategoryLabel(1)) },
              on: {
                click: function($event) {
                  return _vm.changeCategory(1)
                }
              }
            }),
            _vm._v(" "),
            _c("button", {
              class: { active: _vm.activeCategory == 3 },
              domProps: { innerHTML: _vm._s(_vm.userCategoryLabel(3)) },
              on: {
                click: function($event) {
                  return _vm.changeCategory(3)
                }
              }
            }),
            _vm._v(" "),
            _c("button", {
              class: { active: _vm.activeCategory == 4 },
              domProps: { innerHTML: _vm._s(_vm.userCategoryLabel(4)) },
              on: {
                click: function($event) {
                  return _vm.changeCategory(4)
                }
              }
            }),
            _vm._v(" "),
            _c("button", {
              class: { active: _vm.activeCategory == 2 },
              domProps: { innerHTML: _vm._s(_vm.userCategoryLabel(2)) },
              on: {
                click: function($event) {
                  return _vm.changeCategory(2)
                }
              }
            }),
            _vm._v(" "),
            _c("button", {
              class: { active: _vm.activeCategory == 0 },
              domProps: { innerHTML: _vm._s(_vm.userCategoryLabel(0)) },
              on: {
                click: function($event) {
                  return _vm.changeCategory(0)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "reviews", class: { busy: _vm.isBusy } }, [
          _c(
            "ul",
            { staticClass: "unstyled" },
            _vm._l(_vm.items, function(item) {
              return _c("li", { key: item.testimonial_id }, [
                _c(
                  "div",
                  {
                    staticClass: "rating",
                    attrs: { "data-rating": item.rating }
                  },
                  [
                    _c("span", {
                      staticClass: "b-sprite-company-testimonials-rating"
                    })
                  ]
                ),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(
                    "\n            " + _vm._s(item.author) + "\n            "
                  ),
                  item.source != 0
                    ? _c("span", [
                        _vm._v("- " + _vm._s(_vm.sourceLabel(item.source)))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "date" }, [
                  _vm._v(_vm._s(item.testimonial_date))
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(item.text))]),
                _vm._v(" "),
                _c("span", { staticClass: "tag" }, [
                  _vm._v(_vm._s(_vm.userCategoryLabel(item.user_category)))
                ])
              ])
            }),
            0
          ),
          _vm._v(" "),
          _vm.totalPages > 1
            ? _c("div", { staticClass: "pagination" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.previousPage()
                      }
                    }
                  },
                  [_vm._v("<")]
                ),
                _vm._v("\n        " + _vm._s(_vm.page) + " "),
                _c("span", [_vm._v("of")]),
                _vm._v(" " + _vm._s(_vm.totalPages) + "\n        "),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.nextPage()
                      }
                    }
                  },
                  [_vm._v(">")]
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      !_vm.isAuthenticated
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "divider" })
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isAuthenticated
        ? _c("JoinCTA", {
            attrs: {
              "btn-ax-id": "clicked_start_free_trial_from_testimonials_footer"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("LandingFooter")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container summary" }, [
      _c("header", [
        _c("h1", [
          _vm._v("\n        We’re building the "),
          _c("br"),
          _vm._v("\n        best place on Earth to learn "),
          _c("br"),
          _vm._v("\n        math and science.\n      ")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "In the process, we’ve been happy to receive a lot of love from our users."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "title" }, [
        _c("h2", [_vm._v("User reviews")]),
        _vm._v(" "),
        _c("p", [
          _vm._v("Over 50,000 5-star reviews in the App Store and Play Store")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "decoration" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-4bcbc6ac77/images/company/testimonials/testimonials-review-stars-2x.gif"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container press-articles" }, [
      _c("h2", [_vm._v("Press")]),
      _vm._v(" "),
      _c("ul", { staticClass: "unstyled" }, [
        _c("li", [
          _c("div", { staticClass: "img" }, [
            _c("span", { staticClass: "b-sprite-company-publisher-apple" })
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://apps.apple.com/us/story/id1496437493",
                target: "_blank"
              }
            },
            [
              _c("span", [_vm._v("March 2020")]),
              _vm._v("\n          She puzzled it out\n        ")
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "img" }, [
            _c("span", { staticClass: "b-sprite-company-publisher-microsoft" })
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://cloudblogs.microsoft.com/quantum/2019/05/23/microsoft-brilliant-team-up-to-offer-quantum-curriculum/?utm_source=t.co&utm_medium=referral",
                target: "_blank"
              }
            },
            [
              _c("span", [_vm._v("May 2019")]),
              _vm._v(
                "\n          Microsoft, Brilliant team up to offer quantum curriculum\n        "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "img" }, [
            _c("span", { staticClass: "b-sprite-company-publisher-atlantic" })
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href:
                  "http://www.theatlantic.com/magazine/archive/2016/03/the-math-revolution/426855/",
                target: "_blank"
              }
            },
            [
              _c("span", [_vm._v("November 2016")]),
              _vm._v("\n          The Math Revolution\n        ")
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", { staticClass: "img" }, [
            _c("span", { staticClass: "b-sprite-company-publisher-nyt" })
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href:
                  "http://wordplay.blogs.nytimes.com/2016/03/14/brilliant-wrong-approximations-of-pi/",
                target: "_blank"
              }
            },
            [
              _c("span", [_vm._v("March 2016")]),
              _vm._v(
                "\n          Reasonable-Seeming but WRONG Approximations of π\n        "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n      Read more articles about Brilliant\n      "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://docs.google.com/document/d/16BXam0d38RGOqVweRRNm3dyJUs0j3Z0w7u0p41E9H5I/preview?usp=sharing",
              target: "_blank"
            }
          },
          [_vm._v("here.")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }